import { render, staticRenderFns } from "./companyCardForm.vue?vue&type=template&id=f5cbd682&scoped=true&"
import script from "./companyCardForm.vue?vue&type=script&lang=js&"
export * from "./companyCardForm.vue?vue&type=script&lang=js&"
import style0 from "./companyCardForm.vue?vue&type=style&index=0&id=f5cbd682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cbd682",
  null
  
)

export default component.exports